import React from 'react';

import { TEXTS } from 'application/pages/AdsPage/renderer/texts';

import Select from '@zvuk-b2b/react-uikit/ui/Select';

import { AdTypeSelectProps } from './types';
import useAdTypeSelectController from './useAdTypeSelectController';

import styles from './index.module.scss';

const AdTypeSelect = ({
  value,
  initialValue,
  containerClassName,
  isLoading,
  isInstantAdCampaignDisabled,
  isInstantDisabledHintLinkDisabled = false,
  onChange,
  setPromoTab,
  mediaType,
}: AdTypeSelectProps) => {
  const { adCompanyTypeOptions, currentValue } = useAdTypeSelectController({
    value,
    initialValue,
    isInstantAdCampaignDisabled,
    isInstantDisabledHintLinkDisabled,
    onChange,
    setPromoTab,
    mediaType,
  });

  return (
    <div className={containerClassName}>
      <Select
        elementId="select_ad_type_for_form"
        label={TEXTS.SELECT_MODE_TITLE}
        isLoading={isLoading}
        value={currentValue}
        options={adCompanyTypeOptions}
        dropdownItemContentClassName={styles.AdTypeSelectItemContent}
      />
    </div>
  );
};

export default AdTypeSelect;
